import script from "./SettingsItemPoliticalAffiliation.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsItemPoliticalAffiliation.vue?vue&type=script&setup=true&lang=js"

import "./SettingsItemPoliticalAffiliation.vue?vue&type=style&index=0&id=51e927a2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51e927a2"]])

export default __exports__